import { Component, Input } from '@angular/core';

/**
 * ADM-678 (2ª iteración) — aviso de que los datos a la vista son del ambiente de
 * pruebas de Banesco (Calidad), no la cuenta real de Fina.
 *
 * Existe como componente y no como markup repetido porque lo usan tres modales
 * distintos (pago de cuota, acceso bloqueado, solicitud de préstamo) y el copy
 * tiene que ser idéntico en los tres: si en uno dice algo distinto, deja de
 * leerse como un aviso del sistema y empieza a parecer un detalle de esa pantalla.
 *
 * El componente NO decide si mostrarse: el padre lo envuelve en el `*ngIf` de
 * `enabled`, que viene del API. Así el interruptor sigue estando en un solo lugar.
 */
@Component({
    selector: 'fina-staging-data-warning',
    templateUrl: './staging-data-warning.component.html',
    styleUrls: ['./staging-data-warning.component.scss'],
})
export class StagingDataWarningComponent {
    /**
     * Detalle opcional bajo el texto base — p. ej. qué cuenta se está mostrando.
     * Si no se pasa, el aviso queda en una sola línea.
     */
    @Input() detail = '';
}
